import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/antd-mobile@5.42.3_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/antd-mobile/es/global/global.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(app)/index.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/root/index.tsx");
